import Quasar from 'quasar'
import { boot } from 'quasar/wrappers'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import locales from 'src/i18n'

const messages: Json = {}
const numberFormats: Json = {}
const dateTimeFormats: Json = {}
for (const locale in locales) {
  const definitions = locales[locale]
  messages[locale] = definitions.messages
  numberFormats[locale] = definitions.numberFormats
  dateTimeFormats[locale] = definitions.dateTimeFormats
}

declare module 'vue/types/vue' {
  interface Vue {
    i18n: VueI18n
  }
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  numberFormats,
  dateTimeFormats
})

export default boot(({ app }) => {
  // Set i18n instance on app
  app.i18n = i18n

  const { lang } = Quasar as unknown as { lang: { getLocale: () => string} }
  let locale = lang.getLocale().toLowerCase()
  if (!locales[locale]) {
    locale = locale.split('-')[0]
    if (!locales[locale]) {
      locale = 'en'
    }
  }
  setLocale(locale)
})

export function setLocale (locale: string) {
  const { lang } = Quasar as unknown as { lang: { set: (messages: Json) => void} }
  lang.set(locales[locale].quasar)
  i18n.locale = locale
}
